var Glyphicon = require("components/utility/icons/Glyphicon");

require("avatars/owl_shop_color_picker.scss");

class OwlShopColorPicker extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			expanded: false
		};
	}

	buildSelectF(colorIndex) {
		return function() {
			this.props.selectColor(colorIndex, this.props.patchType);
		}.bind(this);
	}

	expand() {
		this.setState({ expanded: true });
	}

	render() {
		var defaultMod = Math.floor(OwlShopColorPicker.COLOR_COUNT / OwlShopColorPicker.DEFAULT_COLOR_COUNT);

		var swatches = _.map(OwlShopColorPicker.COLORS, function(color, index) {
			return (
				<span className="swatch" style={{ background: color }}
					onClick={ this.buildSelectF(index) } key={ color } />
			);
		}.bind(this));

		if (!this.state.expanded) {
			swatches = _.select(swatches, function(swatch, index) {
				return index % defaultMod == 0;
			});

			swatches.push(
				<span className="swatch" onClick={ this.expand } key="expand">				
					<Glyphicon icon={ "plus" } />
				</span>
			);
		}

		return (
			<div className="owlShopColorPicker">
				{ swatches }
			</div>
		);
	}
};

OwlShopColorPicker.COLOR_COUNT = 33;
OwlShopColorPicker.DEFAULT_COLOR_COUNT = 6;

OwlShopColorPicker.COLORS = ["#ED1C24", "#F23929", "#FF5D28", "#FF8E35", "#FFBE43", 
	"#FFEE52", "#D9FE56", "#A3FE55", "#6AFE54", "#38EC51", "#00FE53", "#00EC5E",
	"#00FE78", "#00ED99", "#00FFC5", "#00EDE0", "#00DEFB", "#00A8E7", "#007EF6",
	"#1857E4", "#0F2AF4", "#3B2AE3", "#652AE3", "#8E29E3", "#BF20F5", "#F01DF5", 
	"#FF16D7", "#FF0BA8", "#FF007A", "#F21654", "#3c3c3c", "#a1a0a0", "#764d29"];

OwlShopColorPicker.propTypes = StrictPropTypes({
	// Color value from 0 to COLOR_COUNT - 1
	currentColor: PropTypes.number.isRequired,
	
	patchType: PropTypes.string.isRequired,
	selectColor: PropTypes.func.isRequired
});


module.exports = OwlShopColorPicker;


// WEBPACK FOOTER //
// ./modules/components/avatars/OwlShopColorPicker.js